import {
    APPLY_CHANGE_REQUEST,
    PUBLISH_CHANGE_REQUEST,
    CANCEL_MY_CHANGE_REQUEST,
    REVIEW_CHANGE_REQUEST
} from './redux.actionTypes';

export const applyChangeRequest = ({ handleSubmit, payload }) => ({
    type: APPLY_CHANGE_REQUEST,
    meta: { handleSubmit },
    payload
});

// Submit handler for the reused employee wizard (payload carries the wizard's
// { mode, handleComplete, ... } so the stepper can advance to its Complete step).
export const publishChangeRequest = (payload) => ({
    type: PUBLISH_CHANGE_REQUEST,
    payload
});

export const cancelMyChangeRequest = ({ handleSubmit, payload }) => ({
    type: CANCEL_MY_CHANGE_REQUEST,
    meta: { handleSubmit },
    payload
});

export const reviewChangeRequest = ({ handleSubmit, payload }) => ({
    type: REVIEW_CHANGE_REQUEST,
    meta: { handleSubmit },
    payload
});
